module.exports = __webpack_public_path__ + "img/13.0b4ed46d.svg";